import React, { useState, useEffect } from "react";
import Header from "../../layout/header/header";
import Footer from "../../layout/footer/footer";
import "../subscription/subscription.css";
import {
  doc,
  getDoc,
  getDocs,
  collection,
  updateDoc,
  arrayUnion,
} from "@firebase/firestore";
import { auth, db } from "../../firebase";
import { useAuth } from "../../auth/useAuth";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PaymentGateway from "../payment/PaymentGateway";

const Subscription = () => {
  // payment gateway
  const stripePromise = loadStripe(process.env.REACT_APP_PUB_KEY);

  const [clientSecretKey, setClientSecretKey] = useState("");

  const [processingPayment, setProcessingPayment] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(null);

  const [userData, setUserData] = useState(null);
  const [subscriptions, setSubscriptions] = useState([]);
  const [subToBuy, setSubToBuy] = useState(null);
  const [buySubModal, setBuySubModal] = useState(false);
  const handleOpenBuySubModal = () => setBuySubModal(true);
  const handleCloseBuySubModal = () => {
    // setSubToBuy(null);
    setClientSecretKey("");
    setBuySubModal(false);
  };

  const [paymentResultModal, setPaymentResultModal] = useState(false);
  const handleOpenPaymentResultModal = () => setPaymentResultModal(true);
  const handleClosePaymentResultModal = () => {
    setPaymentDetails(null);
    setProcessingPayment(false);
    setPaymentResultModal(false);
  };

  const { user } = useAuth();

  useEffect(() => {
    if (user && user.uid) {
      fetchUserData();
    }
  }, [user]);

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  const fetchUserData = async () => {
    const docSnap = await getDoc(
      // doc(db, "users", "30INY5CrY1UEs4PfWlYKpdCU22F3")
      doc(db, "users", user.uid)
    );

    if (docSnap.exists()) {
      console.log("USER_DATA:", docSnap.data());
      setUserData(docSnap.data());
    } else {
      // doc.data() will be undefined in this case
      console.log("No user found!");
      setUserData(null);
    }
  };

  const fetchSubscriptions = async () => {
    const querySnapshot = await getDocs(collection(db, "subscriptions"));
    let mSubscriptions = [];
    querySnapshot.forEach((doc) => {
      mSubscriptions.push({ ...doc.data(), id: doc.id });
    });
    console.log(mSubscriptions);
    setSubscriptions(mSubscriptions);
  };

  useEffect(() => {
    if (subToBuy) {
      handleOpenBuySubModal();
    }
  }, [subToBuy]);

  useEffect(() => {
    if (clientSecretKey) {
      setShowPayment(true);
    } else {
      setShowPayment(false);
    }
  }, [clientSecretKey]);

  const updateSubsDB = async (sub) => {
    // TODO: update sub_history & subscriptions in DB
    console.log("SUBTOBUY:", sub);

    const userRef = doc(db, "users", user.uid);

    let today = new Date();
    let valid = new Date();
    valid.setDate(valid.getDate() + 365);

    for (let i = 0; i < sub.subscriptions.length; i++) {
      let subObj = sub.subscriptions[i];
      subObj = {
        ...subObj,
        user_sub_id: `${user.uid}_${today.getTime()}`,
        validity: valid.getTime(),
      };
      sub.subscriptions[i] = subObj;
    }

    let sub_history_to_add = {
      sub_id: sub.id,
      name: sub.name,
      price: sub.price,
      quantity: sub.no_of_services,
      user_sub_id: `${user.uid}_${today.getTime()}`,
      validity: valid.getTime(),
    };
    let subscriptions_to_add = sub.subscriptions;
    console.log(sub.subscriptions);

    await updateDoc(userRef, {
      subscriptions: arrayUnion(...subscriptions_to_add),
      sub_history: arrayUnion(sub_history_to_add),
    });
  };

  useEffect(() => {
    if (paymentDetails) {
      if (paymentDetails.success) {
        updateSubsDB(subToBuy);
      }
      handleCloseBuySubModal();
      handleOpenPaymentResultModal();
    }
  }, [paymentDetails]);

  const [showPayment, setShowPayment] = useState(false);

  const handlePayment = () => {
    const cpiUrl =
      "https://us-central1-homeguru-2e379.cloudfunctions.net/create_payment_intent";
    const amount = 700 * 100;
    const currency = "aed";
    const finalUrl = `${cpiUrl}?amount=${amount}&currency=${currency}`;
    axios
      .post(
        finalUrl,
        {},
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          },
        }
      )
      .then((res) => {
        console.log("PAYMENT INTENT RES:", res);
        if (res.status === 200) {
          setClientSecretKey(res.data.paymentIntent);
        }
      })
      .catch((err) => {
        console.log("PAYMENT INTENT ERR:", { ...err });
      });
  };

  return (
    <div>
      <Header />
      <section className="membership_main">
        <h2>Membership Plans</h2>
        <div className="container-fluid">
          <div className="membership_plane">
            <div className="row">
              {subscriptions.length
                ? subscriptions.map((mSub) => (
                    <div className="col-md-6 col-lg-3" key={mSub.id}>
                      <div className="member_inr">
                        <h4>{mSub.name}</h4>
                        <ul>
                          {mSub.subscriptions.length
                            ? mSub.subscriptions.map((mSer, index) => (
                                <li key={index}>{mSer.name} </li>
                              ))
                            : ""}
                        </ul>
                        <div className="member_inr_btn">
                          <div className="row align-items-center">
                            <div className="col-7">
                              <h6>
                                {mSub.no_of_services} Services per year for{" "}
                              </h6>
                              <h5> {mSub.price} AED/mo</h5>
                            </div>
                            <div
                              className="col-5"
                              onClick={() => {
                                setSubToBuy(mSub);
                                console.log("clicked:", mSub);
                              }}
                            >
                              <a data-toggle="modal" data-target="#myModal">
                                Subscribe
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                : ""}
            </div>
          </div>
        </div>

        <h2>Membership history</h2>
        <div className="container-fluid">
          <div className="membership_plane">
            <div className="row">
              {userData &&
              typeof userData.sub_history !== "undefined" &&
              userData.sub_history.length
                ? userData.sub_history.map((subHistObj) => (
                    <div className="col-md-6 col-lg-3" key={subHistObj.sub_id}>
                      <div className="member_inr">
                        <h4>{subHistObj.name}</h4>
                        <ul>
                          <li>Lorem ipsum dolor sit amet, consectetur </li>
                          <li>Lorem ipsum dolor sit amet, consectetur </li>
                          <li>Lorem ipsum dolor sit amet, consectetur </li>
                          <li>Lorem ipsum dolor sit amet, consectetur </li>
                        </ul>
                        <div className="member_inr_btn">
                          <div className="row align-items-center">
                            <div className="col-7">
                              <h6>
                                {subHistObj.quantity} Services per year for{" "}
                              </h6>
                              <h5>{subHistObj.price}</h5>
                            </div>
                            <div className="col-5">
                              <a data-toggle="modal" data-target="#myModal">
                                Subscribe
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                : ""}
              <div className="col-md-6 col-lg-3">
                <div className="add_members">
                  <i className="fa fa-plus" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />

      {/*  */}
      <Modal
        show={buySubModal}
        onHide={handleCloseBuySubModal}
        className="modal gold_membership"
        id="BuySubModal"
        centered
        tabIndex="-1"
        aria-labelledby="BuySubModal"
        aria-hidden="true"
      >
        <div className="modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <p>{subToBuy?.name}</p>
              <p>{subToBuy?.no_of_services} Services per year for</p>
              <div className="gld_memb d-flex justify-content-between">
                <span>{subToBuy?.price}AED/mo</span> <button>Added</button>
              </div>
              <div className="bill-details">
                <h2 className="d-flex justify-content-between align-items-center">
                  Bill Details <span>Add tip</span>
                </h2>
                {/* <h6 className="d-flex justify-content-between align-items-center">
                  Gold membership Discount <span>$11</span>
                </h6> */}
                <h4 className="d-flex justify-content-between align-items-center">
                  You pay <span>{subToBuy?.price} AED</span>
                </h4>
              </div>
              <div className="gold_membership_btn text-center">
                <button
                  className="btn btn-primary btn-small"
                  onClick={handlePayment}
                >
                  Proceed to pay{" "}
                </button>
                {showPayment && (
                  <Elements
                    stripe={stripePromise}
                    options={{ clientSecret: clientSecretKey }}
                  >
                    <PaymentGateway
                      processingPayment={processingPayment}
                      setProcessingPayment={setProcessingPayment}
                      paymentDetails={paymentDetails}
                      setPaymentDetails={setPaymentDetails}
                    />
                  </Elements>
                )}
              </div>
              {/* <div className="">
                <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
            </div> */}
            </div>
          </div>
        </div>
      </Modal>
      {/*  */}

      {/*  */}
      <Modal
        show={paymentResultModal}
        onHide={handleClosePaymentResultModal}
        className="modal gold_membership"
        id="BuySubModal"
        centered
        tabIndex="-1"
        aria-labelledby="BuySubModal"
        aria-hidden="true"
      >
        <div className="modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                {paymentDetails ? (
                  paymentDetails.success ? (
                    <div>
                      Paid AED {paymentDetails.success.amount / 100}{" "}
                      Successfully!
                      {console.log("RESULT:", paymentDetails.success)}
                    </div>
                  ) : (
                    <div>
                      Something went wrong! Try Again!
                      {console.log("RESULT:", paymentDetails.error)}
                    </div>
                  )
                ) : (
                  ""
                )}

                <button
                  className="btn btn-secondary btn-small center align-center mt-4"
                  onClick={handleClosePaymentResultModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/*  */}
    </div>
  );
};

export default Subscription;
